import { computed, toValue, type MaybeRefOrGetter } from 'vue';

import { useQuery } from '@tanstack/vue-query';

import { ENTITY_LIST_QUERY_OPTIONS } from '../constants';

import { queryKeys } from '../queryKeys';

import { getTeamMemberProperties } from '@/modules/Team/api/teamApi';
import { useTeamDependencies } from '@/modules/Team/composables/useTeamDependencies';

export function useAssignedPropertiesQuery(
  teamMemberId: MaybeRefOrGetter<string | undefined>,
  siteType: MaybeRefOrGetter<string> = 'hotel',
) {
  const { apiClient, accountId } = useTeamDependencies();

  return useQuery({
    queryKey: computed(() => {
      const id = toValue(teamMemberId);
      const type = toValue(siteType);
      return id
        ? queryKeys.properties.assigned(accountId.value, id, type)
        : queryKeys.properties.all;
    }),
    queryFn: () => getTeamMemberProperties({
      accountId: accountId.value,
      teamMemberId: toValue(teamMemberId)!,
      siteType: toValue(siteType),
      deps: { apiClient },
    }),
    enabled: computed(() => Boolean(accountId.value && toValue(teamMemberId))),
    ...ENTITY_LIST_QUERY_OPTIONS,
    select: (response) => response.data,
  });
}
